exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Noto Sans Japanese;font-style:normal;font-weight:300;src:url(//fonts.gstatic.com/ea/notosansjapanese/v6/NotoSansJP-DemiLight.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosansjapanese/v6/NotoSansJP-DemiLight.woff) format('woff'),url(//fonts.gstatic.com/ea/notosansjapanese/v6/NotoSansJP-DemiLight.otf) format('opentype')}dd,dl,dt,h1,h2,h3,h4,h5,h6,li,ol,p,ul{font-weight:200;margin:0;padding:0;list-style:none}img{vertical-align:bottom;-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none;user-drag:none}a{cursor:pointer}a,a:hover{text-decoration:none}body{font-family:Noto Sans Japanese,\\\\6E38\\30B4\\30B7\\30C3\\30AF\\4F53,Yu Gothic,YuGothic,Osaka,'\\FF2D\\FF33   \\FF30\\30B4\\30B7\\30C3\\30AF',sans-serif;background-color:#fff;color:#000;font-size:11px;min-width:1000px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/styles/App.less
 ** module id = 139
 ** module chunks = 0
 **/